<!-- Div used for buttons. Is not a button itself in case we want it to be in an anchor tag -->
<template>
	<div
		class="border-accent-500 text-accent-500 hover:bg-accent-500 flex cursor-pointer items-center gap-1 rounded-sm border bg-white px-1.25 py-0.75 text-xs uppercase hover:text-white"
		:class="[
			bgClass,
			{
				'text-secondary-400 pointer-events-none border-slate-400': disabled,
				'pointer-events-none border-transparent': success,
			},
		]"
	>
		<CheckIcon
			v-if="success"
			class="h-3 w-3"
		/>
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/24/solid'
import { computed } from 'vue'

const props = defineProps({
	disabled: { type: Boolean, default: false },
	success: { type: Boolean, default: false },
	transparent: { type: Boolean, default: false },
})

const bgClass = computed(() => {
	switch (true) {
		case props.success:
		case props.transparent:
			return 'bg-transparent'
		case props.disabled:
			return 'bg-slate-200'
		default:
			return 'bg-white'
	}
})
</script>
